function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHierarchy = function SvgHierarchy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "prefix__Group_160",
    width: 24,
    height: 24,
    "data-name": "Group 160",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_17",
    d: "M0 0h24v24H0z",
    "data-name": "Path 17",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_18",
    d: "M10.111 4H19v1.778h-8.889zm0 3.556h5.333v1.777h-5.333zm0 5.333H19v1.778h-8.889zm0 3.556h5.333v1.778h-5.333zM3 4h5.333v5.333H3zm1.778 1.778v1.778h1.778V5.778zM3 12.889h5.333v5.333H3zm1.778 1.778v1.778h1.778v-1.778z",
    "data-name": "Path 18",
    transform: "translate(1 1)",
    style: {
      fill: "#32325d"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHierarchy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hierarchy.0477abc1.svg";
export { ForwardRef as ReactComponent };